import Cookies from 'js-cookie';

export default intro => {
    // console.log(Cookies.get('animIntro'));
    if (Cookies.get('animIntro') !== 'shown' || Cookies.get('animIntro') === undefined) {
        // start intro animation after 5ms
        setTimeout(() => {    
            intro.classList.add("start");
        }, 500);

        // intro animation end
        setTimeout(() => {
            intro.classList.add('hide');
            intro.addEventListener('transitionend', () => intro.remove(), {once: true});
            Cookies.set('animIntro', 'shown');
        }, 4500);
    } else {
        intro.remove();
    }
};
